<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'
    import { modalStore, stpOrdenesStore } from '../stores'

    import StpService from '../$services/stp.service'
    import StpMethods from '../$methods/stp.methods'

    import Form from '../$components/form.svelte'
    import Date from '../$components/date.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let fecha = Moment().startOf('day').toDate()
    let data = {
        tipoCuentaBeneficiario: 40,
        rfcCurpBeneficiario: 'ND',
        latitud: '',
        longitud: ''
    }

    $: cuentaLen = Number(data.tipoCuentaBeneficiario) === 3 ? 16 : 18

    function onTipoCuenta() {
        const len = Number(data.tipoCuentaBeneficiario) === 3 ? 16 : 18
        if (data.cuentaBeneficiario?.length > len)
            data.cuentaBeneficiario = data.cuentaBeneficiario.slice(0, len)
    }

    $: hasLocation = Boolean(data.latitud && data.longitud)

    function getCoords() {
        return new Promise(resolve => {
            if(!navigator.geolocation)
                return resolve(null)
            navigator.geolocation.getCurrentPosition(
                pos => resolve({
                    latitud: String(pos.coords.latitude),
                    longitud: String(pos.coords.longitude)
                }),
                () => resolve(null)
            )
        })
    }

    getCoords().then(coords => {
        if(!coords)
            return
        data.latitud = coords.latitud
        data.longitud = coords.longitud
    })

    async function createOrden() {

        if(!hasLocation) {
            const coords = await getCoords()
            if(!coords)
                return toast({message: 'Activa la ubicación del navegador para generar la orden', type: 'is-danger'})
            data.latitud = coords.latitud
            data.longitud = coords.longitud
        }

        const payload = {
            ...data,
            fechaOperacion: Number(Moment(fecha).format('YYYYMMDD')),
            institucionContraparte: Number(data.institucionContraparte)
        }

        loading = true
        const resp = await StpService.createOrden(payload)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        stpOrdenesStore.append(resp.data)
        toast({message: 'Orden STP creada', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={ createOrden } { loading } >

    <div class="columns">
        <div class="column">
            <Select bind:value={ data.tipoCuentaBeneficiario }
                label="Tipo de cuenta"
                on:select={ onTipoCuenta }
                options={[
                    {value: 40, text: 'CLABE'},
                    {value: 3, text: 'Tarjeta de débito'},
                ]}
            />
        </div>
    </div>
    
    <div class="columns">
        <div class="column">
            <Select bind:value={ data.institucionContraparte }
                label="Institución contraparte"
                options={ StpMethods.getInstituciones() }
            />
        </div>
        <div class="column">
            <InputText bind:value={ data.cuentaBeneficiario }
                label="Cuenta del beneficiario"
                placeholder={ cuentaLen === 16 ? '16 dígitos' : '18 dígitos' }
                maxlength={ cuentaLen }
                pattern={`[0-9]{${cuentaLen}}`}
            />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.nombreBeneficiario } label="Nombre del beneficiario" placeholder="Nombre" maxlength={40} />
        </div>
        <div class="column">
            <InputText bind:value={ data.rfcCurpBeneficiario } label="RFC / CURP" placeholder="RFC o CURP" maxlength={18} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={ data.monto } label="Monto" placeholder="Monto" />
        </div>
        <div class="column">
            <InputText bind:value={ data.conceptoPago } label="Concepto de pago" placeholder="Máx. 40 caracteres" maxlength={40} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <Date bind:value={ fecha } label="Fecha de operación" showTime={false} />
        </div>
    </div>

    {#if !hasLocation}
        <div class="notification is-warning">Activa la ubicación del navegador para generar la orden.</div>
    {/if}

    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>

</Form>
